import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import { RemoveModal } from 'shared/components/RemoveModal';
import { deleteSafelistTerm } from 'services/safelists/actions';
import { getIsDeletingSafelistTermFlag } from 'services/safelists/getters';

import { RemoveTermModalProps } from './types';

const REMOVE_TERM_MODAL = 'remove-term-modal';

const StyledConfirmationMessage = styled.p`
  max-width: 39.67rem;
  word-wrap: break-word;
  font-size: 1.167rem;
`;

const StyledTermToBeRemoved = styled.span`
  margin: 0 0.33rem;
  font-weight: bold;
`;

const RemoveTermModal = ({
  safelistGuid,
  termToRemove,
}: RemoveTermModalProps) => {
  const dispatch = useDispatch();
  const isTermDeleting = useSelector(getIsDeletingSafelistTermFlag);

  const onSubmit = () => {
    dispatch(deleteSafelistTerm(safelistGuid, termToRemove?.guid));
  };

  return (
    <RemoveModal
      name={REMOVE_TERM_MODAL}
      title='Remove Safelist Item'
      onSubmit={onSubmit}
      isSubmitting={isTermDeleting}
      submitButtonLabel='Remove Safelist Item'
    >
      <StyledConfirmationMessage>
        Are you sure you want to remove the item
        <StyledTermToBeRemoved>{termToRemove.entity}</StyledTermToBeRemoved>
        for all members of your company?
      </StyledConfirmationMessage>
    </RemoveModal>
  );
};

export {
  RemoveTermModal,
  REMOVE_TERM_MODAL,
};
